// src/api/auth.js
import apiClient from './client';

/**
 * Register a new user
 * @param {Object} userData - User data with name, email, password
 * @returns {Promise} Promise with response data
 */
export const registerUser = async (userData) => {
  try {
    const response = await apiClient.post('/auth/register', userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Login user
 * @param {string} email - User email
 * @param {string} password - User password
 * @returns {Promise} Promise with response data containing token and user
 */
export const loginUser = async (email, password) => {
  try {
    // FastAPI uses form data for OAuth2 password flow
    const formData = new FormData();
    formData.append('username', email); // Using email as username
    formData.append('password', password);

    const response = await apiClient.post('/auth/token', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    if (response.data && response.data.access_token) {
      // Store token
      localStorage.setItem('token', response.data.access_token);
      
      // Get user profile with token
      const userResponse = await apiClient.get('/auth/users/me');
      
      // Store user data
      localStorage.setItem('user', JSON.stringify(userResponse.data));
      
      return {
        token: response.data.access_token,
        user: userResponse.data,
      };
    }
    
    throw new Error('Login failed');
  } catch (error) {
    throw error;
  }
};

/**
 * Get current user profile
 * @returns {Promise} Promise with user data
 */
export const getCurrentUser = async () => {
  try {
    const response = await apiClient.get('/auth/users/me');
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Logout user by removing stored token and user data
 */
export const logoutUser = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};